<template>
    <i class="sv-font-icon" :style="[baseStyles, gradationStyle]" :class="classType">

    </i>
</template>
<script lang="ts" src="./sv-font-icon"></script>
<style lang="scss">
@import url('./font-icon/iconfont.css'); 
@import url('./font-icon/sv-font-icon.scss');
</style>